/** 共通の一覧応答（docs/05-api-spec.md 1.2） */
export const DEFAULT_LIMIT = 50;
export const MAX_LIMIT = 200;
/** 1 回の一括操作の上限（docs/02-functional-spec.md 0.2） */
export const MAX_BULK_ITEMS = 1000;
/** CSV 出力の同期上限。超過分は非同期ジョブにする（docs/02-functional-spec.md F05.4） */
export const MAX_CSV_ROWS = 50000;
/** Node とブラウザの双方で動く base64url 変換 */
const toBase64Url = (input) => {
    const bytes = new TextEncoder().encode(input);
    let binary = '';
    for (const byte of bytes)
        binary += String.fromCharCode(byte);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
const fromBase64Url = (input) => {
    const padded = input.replace(/-/g, '+').replace(/_/g, '/');
    const binary = atob(padded.padEnd(Math.ceil(padded.length / 4) * 4, '='));
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return new TextDecoder().decode(bytes);
};
export const encodeCursor = (payload) => toBase64Url(JSON.stringify(payload));
export const decodeCursor = (cursor) => {
    try {
        const parsed = JSON.parse(fromBase64Url(cursor));
        if (typeof parsed?.id !== 'string')
            return null;
        return { v: parsed.v ?? null, id: parsed.id };
    }
    catch {
        return null;
    }
};
/** `-updatedAt` 形式の sort を分解する */
export const parseSort = (sort, allowed, fallback) => {
    if (!sort)
        return fallback;
    const direction = sort.startsWith('-') ? 'desc' : 'asc';
    const field = sort.replace(/^[-+]/, '');
    if (!allowed.includes(field))
        return fallback;
    return { field, direction };
};
//# sourceMappingURL=pagination.js.map